import React from "react";
import ServiceSection from "../components/ServicesSection";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
const ServicePage = () => {
  return (
    <>
      <Navbar />
     
      <ServiceSection/>
      
      <Footer/>
    </>
  );
};

export default ServicePage;